import React, { ReactElement } from 'react';
import WidgetActionsMenu from 'adapter/in/dashboards/pages/Widget/ActionsMenu';
import { useOnDeleteDashboardAnalysisModal } from 'adapter/in/dashboards/containers/Modals/DeleteDashboardAnalysisModal/useDeleteDashboardAnalysisModal';

type WidgetActionsMenuProps = {
    dashboardId: string;
    analysisId: string;
};

export const AnalysisActionsMenuContainer = (props: WidgetActionsMenuProps): ReactElement => {
    const { dashboardId, analysisId } = props;

    const { handleOnDelete, onDeleteModal } = useOnDeleteDashboardAnalysisModal(dashboardId, analysisId);

    return (
        <>
            <WidgetActionsMenu
                show
                showOptions={false}
                onDelete={() => {
                    handleOnDelete();
                }}
            />
            {onDeleteModal}
        </>
    );
};

export default AnalysisActionsMenuContainer;
